import { render, staticRenderFns } from "./ReadMore.vue?vue&type=template&id=923b3414"
import script from "./ReadMore.vue?vue&type=script&lang=js"
export * from "./ReadMore.vue?vue&type=script&lang=js"
import style0 from "./ReadMore.vue?vue&type=style&index=0&id=923b3414&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('923b3414')) {
      api.createRecord('923b3414', component.options)
    } else {
      api.reload('923b3414', component.options)
    }
    module.hot.accept("./ReadMore.vue?vue&type=template&id=923b3414", function () {
      api.rerender('923b3414', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ReadMore.vue"
export default component.exports